// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import Table from "../../../../components/Table";

// MARK: Stores
import RoomStore from "../../../../stores/RoomStore";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	roomStore: RoomStore;
}

@inject("roomStore")
@observer
export default class RoomsTable extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.roomStore.getRooms(0);
	}

	public render() {
		const { roomStore } = this.props;
		return (
			<>
				<Table
					title={strings.rooms.title}
					rows={roomStore.roomsTableRows}
					header={roomStore.header}
					pageOffset={roomStore.pageOffSet}
					loading={roomStore.loading}
					tableIsEmptyMessage={strings.rooms.table.tableIsEmpty}
					prevPage={roomStore.previousPage}
					nextPage={roomStore.nextPage}
					onAddClick={() => roomStore.startRoomCreateOrEdit()}
					onEditClick={(roomId) => roomStore.startRoomCreateOrEdit(roomId)}
					onDeleteClick={(roomId, roomName) => roomStore.openDeleteRoomDialog(roomId, roomName)}
				/>
			</>
		);
	}
}
